import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';

export class StatsItem extends View {
	get template() {
		throw new Error("Need set template for StatsItem class");
	}

	ui() {
		return {
			'coach_locked': '.js-coach-locked'
		};
	}

	events() {
		return {
			'click @ui.coach_locked': 'showCoachPopup'
		};
	}

	initialize() {
		this.initListeners();
	}

	initListeners(){
		this.listenTo( this.model, 'change', this.updateView );
		return this;
	}

	showCoachPopup(event) {
		event.stopPropagation();
		Radio.channel('coach').trigger('show:popup');
	}

	updateView() {
		this.render();
	}
}

export default StatsItem;